package com.fireavert.analytics.client

class AnalyticsUseCase(private val clientAnalyticsRepository: ClientAnalyticsRepository) {
    suspend fun createPageView(path: String) = clientAnalyticsRepository.createPageView(path)
}